import React, { Component } from 'react';
import axios from 'axios';
import { authService } from '../../utils/auth-service';

const hasRESTClient = WrapperComponent => class extends Component {
  constructor(props) {
    super(props);
    const token = authService.getToken();
    this.campaignAPIClient = axios.create({
      baseURL: process.env.REACT_APP_CAMPAIGNS_GET_URL,
      timeout: 6000,
    });
    this.oauthTokenAPIClient = axios.create({
      baseURL: process.env.REACT_APP_AOUTH_TOKEN_API,
      timeout: 15000,
    });
    this.oauthTokenAPIClient.CancelToken = axios.CancelToken;
    this.oauthTokenAPIClient.isCancel = axios.isCancel;
    this.restClient = axios.create({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  }

  buildRESTClient = ({
    baseURL = process.env.REACT_APP_API_BASE_URL,
    hasToken = true,
    timeout,
  }) => {
    const token = authService.getToken();
    return axios.create({
      baseURL,
      timeout: timeout || 6000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: hasToken ? `Bearer ${token}` : undefined,
      },
    });
  }

  render() {
    return (<WrapperComponent
      {...this.props}
      restClient={this.restClient}
      campaignAPIClient={this.campaignAPIClient}
      oauthTokenAPIClient={this.oauthTokenAPIClient}
      buildRESTClient={this.buildRESTClient}
    />);
  }
};

export default hasRESTClient;



/** WEBPACK FOOTER **
 ** ./src/hocs/has-rest-client/index.js
 **/